import { CreateOAuthUrlPayload, OAuthUrl } from './types';
import { LoadingStates } from '../../constants';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface OAuthUrlsState {
  entities: {
    oauthUrls: OAuthUrl[];
  };
  ui: {
    loading: {
      state: string;
    };
    createLoading: {
      state: string;
    };
    createSuccess: boolean;
    createError: string | null;
    createdOAuthUrl: OAuthUrl | null;
    notifications: Array<{
      state: string;
      message: string;
    }>;
  };
}

export const initialState: OAuthUrlsState = {
  entities: {
    oauthUrls: [],
  },
  ui: {
    loading: {
      state: LoadingStates.IDLE,
    },
    createLoading: {
      state: LoadingStates.IDLE,
    },
    createSuccess: false,
    createError: null,
    createdOAuthUrl: null,
    notifications: [],
  },
};

const oauthUrlsSlice = createSlice({
  name: 'oauthUrls',
  initialState,
  reducers: {
    fetchOAuthUrls: (state) => {
      state.ui.loading.state = LoadingStates.LOADING;
    },
    setOAuthUrls: (state, action: PayloadAction<OAuthUrl[]>) => {
      state.entities.oauthUrls = action.payload;
      state.ui.loading.state = LoadingStates.DONE;
    },
    setOAuthUrlsLoading: (state, action: PayloadAction<{ state: string }>) => {
      state.ui.loading.state = action.payload.state;
    },
    createOAuthUrl: (state, action: PayloadAction<CreateOAuthUrlPayload>) => {
      state.ui.createLoading.state = LoadingStates.LOADING;
      state.ui.createSuccess = false;
      state.ui.createError = null;
    },
    setCreateOAuthUrlSuccess: (state, action: PayloadAction<OAuthUrl>) => {
      state.ui.createLoading.state = LoadingStates.DONE;
      state.ui.createSuccess = true;
      state.ui.createdOAuthUrl = action.payload;
      state.ui.createError = null;
      state.entities.oauthUrls.unshift(action.payload);
    },
    setCreateOAuthUrlError: (state, action: PayloadAction<string>) => {
      state.ui.createLoading.state = LoadingStates.ERROR;
      state.ui.createSuccess = false;
      state.ui.createError = action.payload;
    },
    resetCreateOAuthUrlState: (state) => {
      state.ui.createLoading.state = LoadingStates.IDLE;
      state.ui.createSuccess = false;
      state.ui.createError = null;
      state.ui.createdOAuthUrl = null;
    },
    addNotification: (
      state,
      action: PayloadAction<{ state: string; message: string }>
    ) => {
      state.ui.notifications.push(action.payload);
    },
    removeNotification: (state, action: PayloadAction<number>) => {
      state.ui.notifications.splice(action.payload, 1);
    },
  },
});

export const {
  fetchOAuthUrls,
  setOAuthUrls,
  setOAuthUrlsLoading,
  createOAuthUrl,
  setCreateOAuthUrlSuccess,
  setCreateOAuthUrlError,
  resetCreateOAuthUrlState,
  addNotification,
  removeNotification,
} = oauthUrlsSlice.actions;

export default oauthUrlsSlice.reducer;
